import * as $ from "jquery";

export class Nav {
  $skelem = ".sk-m-nav-wap";

  skAfterViewChecked(): void {
    this.skUpdateView();
  }
  skUpdateView(): void {}

  navToggle(): void {
    const navDom = $(".menuImg").next();
    const backDom = $(".menuImg").siblings(".shadeBack");
    navDom.toggleClass("showSelf");
    backDom.toggleClass("showSelf");
    if (backDom.hasClass("showSelf")) {
      $("body").css("height", "100vh").css("overflow", "hidden");
    } else {
      $("body").css("height", "auto").css("overflow", "auto");
    }
  }
  itemActive(event): void {
    let currentNode = event.target;
    if (event.target.classList.contains("cutBox")) {
      currentNode = event.target.parentNode;
    }
    if (currentNode.classList.contains("active") == false) {
      currentNode.classList.add("active");
    } else {
      currentNode.classList.remove("active");
    }
  }
}
